import "./PrivacyTermsAndDisclaimers.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyOverview from "./sections/PrivacyPolicyOverview";
import DetailedPrivacyPolicy from "./sections/DetailedPrivacyPolicy";
import Disclaimer from "./sections/Disclaimer";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyTermsAndDisclaimersPage() {
  return <div>
      <Header />
      <PrivacyPolicyOverview />
      <DetailedPrivacyPolicy />
      <Disclaimer />
      <Footer />
    </div>;
}